import axios from "axios";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import DataTable from "react-data-table-component";
import { tariffChargeTableCustomStyles, tariffChargeBulkTableCustomStyles } from "../../utils/TableCustomStyles";
import Select from "react-select";
import { format } from "date-fns";
import { FilterFormSelectCustomStyles, smallFormSelectCustomStyles } from "../../utils/SelectCustomStyles";
import { FileUploader } from "react-drag-drop-files";
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const fileTypes = ["XLS", "XLSX"];

function TariffCharge() {
  const searchform = useRef(null);
  const addchargeform = useRef(null);
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] = useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage['userrole']  
  const user_id = sessionStorage['id']
  const [loggedInUser, setLoggedInUser] = useState(null);

  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasFullScreen, setCanvasFullScreen] = useState(false);


  const [recordForDelete, setRecordForDelete] = useState(null);
  const [showSearchForm, setShowSearchForm] = useState(false);
  
  const [tariffChargeList, setTariffChargeList] = useState([]);
  const [chargeDataPending, setChargeDataPending] = useState(false);

  // ------------------------------------ ADD Tariff Charges --------------------------------------------
  
  const [portList, setPortList] = useState([]);
  const [bulkPortList, setBulkPortList] = useState([]);
  const [filterPortList, setFilterPortList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [filterProductList, setFilterProductList] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [bulkAgentList, setBulkAgentList] = useState([]);
  const [filterAgentList, setFilterAgentList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [bulkVendorList, setBulkVendorList] = useState([]);
  const [filterVendorList, setFilterVendorList] = useState([]);
  const [terminalList, setTerminalList] = useState([]);
  const [bulkTerminalList, setBulkTerminalList] = useState([]);
  const [allTerminalList, setAllTerminalList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [bulkCurrencyList, setBulkCurrencyList] = useState([]);
  const [isTerminalSpecificCharge, setIsTerminalSpecificCharge] = useState("NO");
  const [chargeTerminal, setChargeTerminal] = useState("");
  const [showAddChargeLoader, setShowAddChargeLoader] = useState(false);
  const [showUpdateChargeLoader, setShowUpdateChargeLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);
  
  

  const [showPortError, setShowPortError] = useState(false);
  const [showChargeNameError, setShowChargeNameError] = useState(false);
  const [showProductError, setShowProductError] = useState(false);
  const [showAgentError, setShowAgentError] = useState(false);
  const [showVendorError, setShowVendorError] = useState(false);
  const [showChargeTypeError, setShowChargeTypeError] = useState(false);
  const [showChargeCategoryError, setShowChargeCategoryError] = useState(false);
  const [showChargeBasisError, setShowChargeBasisError] = useState(false);
  const [showAmountError, setShowAmountError] = useState(false);
  const [showAmountTypeError, setShowAmountTypeError] = useState(false);
  const [showExpenseError, setShowExpenseError] = useState(false);
  const [showChargeCurrencyError, setShowChargeCurrencyError] = useState(false);
  const [showApplicableForError, setShowApplicableForError] = useState(false);
  const [showTerminalError, setShowTerminalError] = useState(false);
  const [showValidFromError, setShowValidFromError] = useState(false);
  const [showValidToError, setShowValidToError] = useState(false);


  // ------------------------------------ Update Tariff Charges --------------------------------------------
  const [updateId, setUpdateId] = useState("");
  const [updateChargePort, setUpdateChargePort] = useState("");
  const [updateChargeProduct, setUpdateChargeProduct] = useState("");
  const [updateChargeAgent, setUpdateChargeAgent] = useState("");
  const [updateChargeVendor, setUpdateChargeVendor] = useState("");
  const [updateChargeType, setUpdateChargeType] = useState("");
  const [updateChargeName, setUpdateChargeName] = useState("");
  const [updateChargeCategory, setUpdateChargeCategory] = useState("");
  const [updateChargeBasis, setUpdateChargeBasis] = useState("");
  const [updateChargeCurrency, setUpdateChargeCurrency] = useState("");
  const [updateChargeAmount, setUpdateChargeAmount] = useState(0);
  const [updateChargeAmountType, setUpdateChargeAmountType] = useState("");
  const [updateChargeExpense, setUpdateChargeExpense] = useState(0);
  const [updateApplicableFor, setUpdateApplicableFor] = useState("");
  const [updateIsTerminalSpecificCharge, setUpdateIsTerminalSpecificCharge] = useState("NO");
  const [updateChargeTerminal, setUpdateChargeTerminal] = useState("");
  const [updateChargeEventType, setUpdateChargeEventType] = useState("");
  const [updateChargeEventSubType, setUpdateChargeEventSubType] = useState("");
  const [updateIsMandatoryCharge, setUpdateIsMandatoryCharge] = useState(false);
  const [updateChargePayableBy, setUpdateChargePayableBy] = useState("");
  const [updateChargeValidFrom, setUpdateChargeValidFrom] = useState("");
  const [updateChargeValidTo, setUpdateChargeValidTo] = useState("");
  const [updateChargeRemarks, setUpdateChargeRemarks] = useState("");
  const [updateChargeIsActive, setUpdateChargeIsActive] = useState("");

  const [showUpdatePortError, setShowUpdatePortError] = useState(false);
  const [showUpdateChargeNameError, setShowUpdateChargeNameError] = useState(false);
  const [showUpdateProductError, setShowUpdateProductError] = useState(false);
  const [showUpdateAgentError, setShowUpdateAgentError] = useState(false);
  const [showUpdateVendorError, setShowUpdateVendorError] = useState(false);
  const [showUpdateChargeTypeError, setShowUpdateChargeTypeError] = useState(false);
  const [showUpdateChargeCategoryError, setShowUpdateChargeCategoryError] = useState(false);
  const [showUpdateChargeBasisError, setShowUpdateChargeBasisError] = useState(false);
  const [showUpdateAmountError, setShowUpdateAmountError] = useState(false);
  const [showUpdateAmountTypeError, setShowUpdateAmountTypeError] = useState(false);
  const [showUpdateExpenseError, setShowUpdateExpenseError] = useState(false);
  const [showUpdateChargeCurrencyError, setShowUpdateChargeCurrencyError] = useState(false);
  const [showUpdateApplicableForError, setShowUpdateApplicableForError] = useState(false);
  const [showUpdateTerminalError, setShowUpdateTerminalError] = useState(false);
  const [showUpdateValidFromError, setShowUpdateValidFromError] = useState(false);
  const [showUpdateValidToError, setShowUpdateValidToError] = useState(false);


  // ------------------------------------ Bulk Upload Tariff Charges --------------------------------------------
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [showBulkUploadLoader, setShowBulkUploadLoader] = useState(false);
  const [bulkUploadFile, setBulkUploadFile] = useState(null);
  const [bulkUploadChargesData, setBulkUploadChargesData] = useState([]);
  const [bulkUploadDataPending, setBulkUploadDataPending] = useState(false);
  const [showDeleteBulkChargeModal, setShowDeleteBulkChargeModal] = useState(false);
  const [bulkRecordForDelete, setBulkRecordForDelete] = useState("");
  const [showDeleteBulkLoader, setShowDeleteBulkLoader] = useState(false);
  const [showDeleteSelectedBulkLoader, setShowDeleteSelectedBulkLoader] = useState(false);
  const [selectedTariffCharges, setSelectedTariffCharges] = useState([]);
  const [uploadFileKey, setUploadFileKey] = useState(Date.now());
  


  const getLoggenInUser = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/user/'+user_id);
        if (response) {
            setLoggedInUser(response.data)
        }
    } catch (err) {
        toast.error("Error in fetching user data! Try again.");
    }
  }

  const getPort = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/port/');
        const filter_data = response.data.map(item => ({ value: item.id, label: item.name, type: item.type, internal_id: item.internal_id }));
        const port_sorted_data = [...filter_data].sort((a, b) => a.label.localeCompare(b.label));
        setFilterPortList(port_sorted_data)
        setPortList(port_sorted_data)

        const portNames = response.data.map(port => port.name).sort((a, b) => a.localeCompare(b));
        setBulkPortList(portNames)
    } catch (err) {
        toast.error("Error in fetching port data! Try again.");
    }
  }

  const getCurrency = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/currency/');
        const currency_data = response.data
        const sorted_data = currency_data.sort((a, b) => a.name - b.name)
        setCurrencyList(sorted_data)

        const currencyNames = response.data.map(currency => currency.value);
        setBulkCurrencyList(currencyNames)
    } catch (err) {
        toast.error("Error in fetching currency data! Try again.");
    }
  }

  const getTariffCharges = async () => {
    try {
        setChargeDataPending(true)
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/tariffcharge');
        const charge_data = response.data
        const sorted_data = charge_data.sort((a, b) => a.charge_name - b.charge_name)
        setTariffChargeList(sorted_data)
        setChargeDataPending(false)
    } catch (err) {
        toast.error("Error in fetching tariff charge data! Try again.");
    }
  }

  const getProduct = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/product/');
        const product_data = response.data
        const sorted_data = product_data.sort((a, b) => a.product_name - b.product_name)
        setProductList(sorted_data)

        const filter_data = response.data.map(item => ({ value: item.id, label: item.product_name, internal_id: item.internal_id }));
        const product_sorted_data = [...filter_data].sort((a, b) => a.label.localeCompare(b.label));
        setFilterProductList(product_sorted_data)
    } catch (err) {
        toast.error("Error in fetching product data! Try again.");
    }
  }

  const getAgent = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/agent/');
        const filter_data = response.data.map(item => ({ value: item.id, label: item.name, internal_id: item.internal_id }));
        const agent_sorted_data = [...filter_data].sort((a, b) => a.label.localeCompare(b.label));
        setFilterAgentList(agent_sorted_data)
        setAgentList(agent_sorted_data)

        const agentNames = response.data.map(agent => agent.name);
        setBulkAgentList(agentNames)
    } catch (err) {
        toast.error("Error in fetching agent data! Try again.");
    }
  }

  const getVendor = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/vendor/');
        const filter_data = response.data.map(item => ({ value: item.id, label: item.name, internal_id: item.internal_id }));
        const vendor_sorted_data = [...filter_data].sort((a, b) => a.label.localeCompare(b.label));
        setFilterVendorList(vendor_sorted_data)
        setVendorList(vendor_sorted_data)

        const vendorNames = response.data.map(vendor => vendor.name);
        setBulkVendorList(vendorNames)
    } catch (err) {
        toast.error("Error in fetching vendor data! Try again.");
    }
  }

  const getTerminal = async (port_id) => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/terminal?port__id='+port_id);
        const terminal_data = response.data
        const sorted_data = terminal_data.sort((a, b) => a.name - b.name)
        setTerminalList(sorted_data)
    } catch (err) {
        toast.error("Error in fetching terminal data! Try again.");
    }
  }

  const getAllTerminal = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/terminal/');
        const terminal_data = response.data
        const sorted_data = terminal_data.sort((a, b) => a.name - b.name)
        setAllTerminalList(sorted_data)

        const terminalNames = response.data.map(terminal => terminal.name);
        setBulkTerminalList(terminalNames)
    } catch (err) {
        toast.error("Error in fetching terminal data! Try again.");
    }
  }

  const getCurrentUserRolePermission = async (roles) => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/role/getuserrolepermission?roles='+roles);
        
        const role_permissions_array = []
        for(let i=0; i<response.data?.length; i++){
            for(let j=0; j<response?.data[i]?.permissions_array?.length; j++){
                if(!role_permissions_array.includes(response?.data[i]?.permissions_array?.[j])){
                    role_permissions_array.push(response?.data[i]?.permissions_array?.[j])
                }
            }
        }

        if(role_permissions_array){
            setCurrentUserRolePermissionData(role_permissions_array)
        }
          
    } catch (err) {
        toast.error("Error in fetching user role data! Try again.");
    }
  }

  useEffect(() => {
    getLoggenInUser()
    getTariffCharges()
    getCurrency()
    getPort()
    getProduct()
    getAgent()
    getVendor()
    getAllTerminal()
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role)
  }, [user_role]);

  // -------------------------------------------- Tariff Charges --------------------------------------------------
  const tariffchargecolumns = [
    {
      name: 'Service Provider',
      width: '200px',
      selector: row => <div className="text-left">
          <span><b>Agent:</b> {row.agent_data?.name}</span><br></br>
          <span><b>Vendor:</b> {row.vendor_data?.name}</span>
        </div>,
      sortable: true,
    },
    {
      name: 'Charge Details',
      selector: row => <div className="text-left">
        <span><b>Charge Name: </b>{row.charge_name}</span><br></br>
        <span><b>Product: </b>{row.product_data?.product_name}</span><br></br>
        <span><b>Charge Type: </b>
              <span className={`${row.charge_type =="HAZARDOUS"?"text-danger":""}`}>{row.charge_type.replaceAll("_"," ")}</span>
        </span><br></br>
        <span><b>Charge Category: </b>{row.charge_category.replaceAll("_"," ")}</span><br></br>
        <span><b>Charge Basis: </b>{row.charge_basis.replaceAll("_"," ")}</span>
      </div>,
      width: '300px',
      sortable: true,
    },
    {
      name: 'Amount and Expense',
      width: '180px',
      selector: row => <div className="text-left">
          <span><b>Amount:</b> {row.currency_data?.symbol} {row.amount}</span><br></br>
          <span><b>Amount Type:</b> {row.amount_type}</span><br></br>
          <span><b>Expense:</b> {row.currency_data?.symbol} {row.expense}</span>
        </div>,
      sortable: true,
    },
    {
      name: 'Port',
      width: '250px',
      selector: row => row.port_data?.name,
      sortable: true,
    },
    {
      name: 'Applicable For',
      width: '150px',
      selector: row => row.applicable_for,
      sortable: true,
    },
    {
      name: 'Validity',
      width: '200px',
      selector: row => <div className="text-left">
          <span><b>Valid From:</b> {format(new Date(row.valid_from), "dd/MM/yyyy")}</span><br></br>
          <span><b>Valid To:</b> {format(new Date(row.valid_to), "dd/MM/yyyy")}</span>
        </div>,
      sortable: true,
    },
    {
      name: 'Other',
      width: '300px',
      selector: row => <div className="text-left">
          <span><b>Is Mandatory:</b> {row.is_mandatory_charge == true?"YES":"NO"}</span><br></br>
          <span><b>Is Terminal Specific:</b> {row.is_terminal_specific_charge == true?"YES":"NO"}</span><br></br>
          <span><b>Terminal:</b> {row.terminal_data?.name}</span><br></br>
          <span><b>Event Type:</b> {row.event_type.replaceAll("_"," ")}</span><br></br>
          <span><b>Event SUb-Type:</b> {row.event_sub_type.replaceAll("_"," ")}</span>
        </div>,
      sortable: true,
    },
    {
      name: 'Payable By',
      width: '120px',
      selector: row => row.payable_by,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("draftbooking:tariffcharge:update")?
          <Button className="btn btn-sm btn-inox-green border-0" title="Update" data-bs-toggle="offcanvas" data-bs-target="#updateSection" onClick={() => handleSetUpdateData(row)}>
            <i className="fa fa-edit"></i>
          </Button>
          :
          ""
        }

        {
          currentUserRolePermissionData?.includes("draftbooking:tariffcharge:delete")?
          <Button className="btn btn-sm bg-danger border-0 mx-2" title="Delete" onClick={() => handleDeleteModalOpen(row)}>
            <i className="fa fa-trash"></i>
          </Button>
          :
          ""
        }
      </div>,
    }
  ];

  const addTariffCharge = async (e) => {
    e.preventDefault();
    setShowAddChargeLoader(true)

    const data = {
      port: addchargeform.current.port.value,
      charge_name: addchargeform.current.charge_name.value,
      product: addchargeform.current.product.value,
      agent: addchargeform.current.agent.value,
      vendor: addchargeform.current.vendor.value,
      charge_category: addchargeform.current.charge_category.value,
      charge_type: addchargeform.current.charge_type.value,
      charge_basis: addchargeform.current.charge_basis.value,
      amount: addchargeform.current.amount.value,
      amount_type: addchargeform.current.amount_type.value,
      expense: addchargeform.current.expense.value,
      currency: addchargeform.current.currency.value,
      is_mandatory_charge: addchargeform.current.is_mandatory.value,
      is_terminal_specific_charge: addchargeform.current.is_terminal_specific.value == "YES"?true:false,
      terminal: chargeTerminal,
      applicable_for: addchargeform.current.applicable_for.value,
      event_type: addchargeform.current.event_type.value,
      event_sub_type: addchargeform.current.event_sub_type.value,
      payable_by: addchargeform.current.payable_by.value,
      valid_from: addchargeform.current.valid_from.value,
      valid_to: addchargeform.current.valid_to.value,
      remarks: addchargeform.current.remarks.value,
      is_active: addchargeform.current.is_active.value,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL+'/master/tariffcharge/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );
    if (response.status === 201 ) {
      toast.success("Tariff Charge Added Successfully")
      addchargeform.current.port.value = ""
      addchargeform.current.charge_name.value = ""
      addchargeform.current.product.value = ""
      addchargeform.current.agent.value = ""
      addchargeform.current.vendor.value = ""
      addchargeform.current.charge_category.value = ""
      addchargeform.current.charge_type.value = ""
      addchargeform.current.charge_basis.value = ""
      addchargeform.current.amount.value = ""
      addchargeform.current.amount_type.value = ""
      addchargeform.current.expense.value = ""
      addchargeform.current.currency.value = ""
      addchargeform.current.is_mandatory.value = true
      addchargeform.current.is_terminal_specific.value = "NO"
      addchargeform.current.terminal.value = ""
      addchargeform.current.event_type.value = ""
      addchargeform.current.event_sub_type.value = ""
      addchargeform.current.applicable_for.value = ""
      addchargeform.current.valid_from.value = ""
      addchargeform.current.valid_to.value = ""
      addchargeform.current.remarks.value = ""
      addchargeform.current.is_active.value = true
      setIsTerminalSpecificCharge("NO")
      setChargeTerminal("")
    }
    getTariffCharges()
    setShowAddChargeLoader(false)
  }

  const handleSetUpdateData = (row) => {
    setShowUpdateCanvas(true)
    setUpdateId(row.id)
    setUpdateChargePort({"value": row.port_data?.id, "label": row.port_data?.name})
    setUpdateChargeProduct(row.product)
    setUpdateChargeAgent({"value": row.agent_data?.id, "label": row.agent_data?.name})
    setUpdateChargeVendor({"value": row.vendor_data?.id, "label": row.vendor_data?.name})
    setUpdateChargeType(row.charge_type)
    setUpdateChargeName(row.charge_name)
    setUpdateChargeCategory(row.charge_category)
    setUpdateChargeBasis(row.charge_basis)
    setUpdateChargeCurrency(row.currency)
    setUpdateChargeAmount(row.amount)
    setUpdateChargeAmountType(row.amount_type)
    setUpdateChargeExpense(row.expense)
    setUpdateIsTerminalSpecificCharge(row.is_terminal_specific_charge)
    setUpdateChargeTerminal(row.terminal)
    setUpdateChargeEventType(row.event_type)
    setUpdateChargeEventSubType(row.event_sub_type)
    setUpdateApplicableFor(row.applicable_for)
    setUpdateIsMandatoryCharge(row.is_mandatory_charge)
    setUpdateChargePayableBy(row.payable_by)
    setUpdateChargeValidFrom(row.valid_from)
    setUpdateChargeValidTo(row.valid_to)
    setUpdateChargeRemarks(row.remarks)
    setUpdateChargeIsActive(row.is_active)
    getTerminal(row.port)
  }

  const updateTariffCharge = async (e) => {
    e.preventDefault();
    setShowUpdateChargeLoader(true)

    const data = {
      port: updateChargePort?.value,
      charge_name: updateChargeName,
      product: updateChargeProduct,
      agent: updateChargeAgent?.value,
      vendor: updateChargeVendor?.value,
      charge_category: updateChargeCategory,
      charge_type: updateChargeType,
      charge_basis: updateChargeBasis,
      amount: updateChargeAmount,
      amount_type: updateChargeAmountType,
      expense: updateChargeExpense,
      currency: updateChargeCurrency,
      is_mandatory_charge: updateIsMandatoryCharge,
      is_terminal_specific_charge: updateIsTerminalSpecificCharge,
      terminal: updateChargeTerminal,
      event_type: updateChargeEventType,
      event_sub_type: updateChargeEventSubType,
      applicable_for: updateApplicableFor,
      payable_by: updateChargePayableBy,
      valid_from: updateChargeValidFrom,
      valid_to: updateChargeValidTo,
      remarks: updateChargeRemarks,
      is_active: updateChargeIsActive,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL+'/master/tariffcharge/'+updateId+'/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );
    if (response.status === 200 ) {
      toast.success("Tariff Charge Updated Successfully")
    }
    getTariffCharges()
    setShowUpdateChargeLoader(false)
  }

  const handleDeleteModalClose = () => {
    setShowDeleteModal(false)
  }

  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true)
    setRecordForDelete(data)
  }

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true)
    try {
        await axios.delete(process.env.REACT_APP_BACKEND_API_URL+'/master/tariffcharge/'+id+'/');
        setShowDeleteModal(false)
        toast.success("Record deleted successfully")
        getTariffCharges()
    } catch (err) {
        toast.error("Error in deleting record! Try again.");
    }
    getTariffCharges()
    setShowDeleteLoader(false)
  }

  const searchTariffCharge = async (e) => {
    const charge_name = searchform.current.search_charge_name.value
    const port = searchform.current.search_charge_port.value
    const agent = searchform.current.search_charge_agent.value
    const vendor = searchform.current.search_charge_vendor.value
    const container = searchform.current.search_container_type.value
    const charge_category = searchform.current.search_charge_category.value
    const charge_basis = searchform.current.search_charge_basis.value
    const charge_type = searchform.current.search_charge_type.value
    const event_type = searchform.current.search_charge_event_type.value
    const event_sub_type = searchform.current.search_charge_event_sub_type.value

    const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/tariffcharge?charge_name__icontains='+charge_name+
                                                                          '&port='+port+'&agent='+agent+'&vendor='+vendor+'&product='+container+
                                                                          '&charge_category='+charge_category+'&charge_basis='+charge_basis+
                                                                          '&charge_type='+charge_type+'&event_type='+event_type+
                                                                          '&event_sub_type='+event_sub_type
                                                                        );
    setTariffChargeList(response.data)
  }


  // -------------------------------------------- Bulk Upload Tariff Charges --------------------------------------------------
  const filter_data = (data_list, filter_value, column_name) => {
    if(column_name=="port"){
      const filtered_data = data_list.filter(port => port.label == filter_value);
      return filtered_data?.[0]?.label
    }
    else if(column_name=="terminal"){
      const filtered_data = data_list.filter(terminal => terminal.name == filter_value);
      return filtered_data?.[0]?.name ?? <span className="text-danger">NONE</span>
    }
    else if(column_name=="agent"){
      const filtered_data = data_list.filter(agent => agent.label == filter_value);
      return filtered_data?.[0]?.label
    }
    else if(column_name=="vendor"){
      const filtered_data = data_list.filter(vendor => vendor.label == filter_value);
      return filtered_data?.[0]?.label
    }
    else if(column_name=="product"){
      const filtered_data = data_list.filter(product => product.internal_id == filter_value);
      return filtered_data?.[0]?.product_name
    }
    else if(column_name=="currency"){
      const filtered_data = data_list.filter(currency => currency.value == filter_value);
      return filtered_data?.[0]?.symbol ?? <span className="text-danger">$</span>
    }
    else{
      return ""
    }
  }

  const tariffChargeExist = (charge_name, charge_type, charge_category, product, port, agent, vendor, terminal) => {
    if(terminal){
      const exist = tariffChargeList.some(tariff => tariff.charge_name == charge_name && 
                                    tariff.charge_type == charge_type &&
                                    tariff.charge_category == charge_category &&
                                    tariff.product_data?.internal_id == product &&
                                    tariff.port_data?.name == port && 
                                    tariff.agent_data?.name == agent && 
                                    tariff.vendor_data?.name == vendor &&
                                    tariff.terminal_data?.name == terminal
                                  );
      
      return exist
    }
    else{
      const exist = tariffChargeList.some(tariff => tariff.charge_name == charge_name && 
                                    tariff.charge_type == charge_type &&
                                    tariff.charge_category == charge_category &&
                                    tariff.product_data?.internal_id == product &&
                                    tariff.port_data?.name == port && 
                                    tariff.agent_data?.name == agent && 
                                    tariff.vendor_data?.name == vendor
                                  );
      return exist
    }
  }

  const tariffChargeBulkConditionalRowCustomStyles = [
    {
      when: row => tariffChargeExist(row.charge_name, row.charge_type, row.charge_category, row.product, row.port, row.agent, row.vendor, row.terminal) == true,
      style: {
        backgroundColor: '#FFEBEE',
        color: '#B71C1C',
      },
    },
    {
      when: row => row.active === false,
      style: {
        backgroundColor: '#FFEBEE',
        color: '#B71C1C',
      },
    },
  ]

  function excelDateToJSDate(serial) {
    const excelEpoch = new Date(1899, 11, 30);
    const jsDate = new Date(excelEpoch.getTime() + serial * 24 * 60 * 60 * 1000);
    return jsDate;
  }

  const bulkuploadcolumns = [
    {
      name: 'Tariff',
      width: '100px',
      selector: row => tariffChargeExist(row.charge_name, row.charge_type, row.charge_category, row.product, row.port, row.agent, row.vendor, row.terminal)?<b>Exists</b>:"New Tariff",
      sortable: true,
    },
    {
      name: 'Service Provider',
      width: '200px',
      selector: row => <div className="text-left">
          <span><b>Agent:</b> {filter_data(agentList, row.agent, "agent")}</span><br></br>
          <span><b>Vendor:</b> {filter_data(vendorList, row.vendor, "vendor")}</span>
        </div>,
      sortable: true,
    },
    {
      name: 'Charge Details',
      selector: row => <div className="text-left">
        <span><b>Charge Name: </b>{row.charge_name}</span><br></br>
        <span><b>Product: </b>{filter_data(productList, row.product, "product")}</span><br></br>
        <span><b>Charge Type: </b>
              <span className={`${row.charge_type =="HAZARDOUS"?"text-danger":""}`}>{row.charge_type.replaceAll("_"," ")}</span>
        </span><br></br>
        <span><b>Charge Category: </b>{row.charge_category.replaceAll("_"," ")}</span><br></br>
        <span><b>Charge Basis: </b>{row.charge_basis.replaceAll("_"," ")}</span>
      </div>,
      width: '250px',
      sortable: true,
    },
    {
      name: 'Amount and Expense',
      width: '170px',
      selector: row => <div className="text-left">
          <span><b>Amount:</b> {filter_data(currencyList, row.currency, "currency")} {row.amount}</span><br></br>
          <span><b>Amount Type:</b> {row.amount_type}</span><br></br>
          <span><b>Expense:</b> {filter_data(currencyList, row.currency, "currency")} {row.expense}</span>
        </div>,
      sortable: true,
    },
    {
      name: 'Port',
      width: '240px',
      selector: row => filter_data(portList, row.port, "port"),
      sortable: true,
    },
    {
      name: 'Applicable For',
      width: '130px',
      selector: row => row.applicable_for,
      sortable: true,
    },
    {
      name: 'Validity',
      width: '170px',
      selector: row => <div className="text-left">
          <span><b>Valid From:</b> {row.valid_from?excelDateToJSDate(row.valid_from).toLocaleDateString():""}</span><br></br>
          <span><b>Valid To:</b> {row.valid_to?excelDateToJSDate(row.valid_to).toLocaleDateString():""}</span>
        </div>,
      sortable: true,
    },
    {
      name: 'Other',
      width: '300px',
      selector: row => <div className="text-left">
          <span><b>Is Mandatory:</b> {row.is_mandatory_charge}</span><br></br>
          <span><b>Is Terminal Specific:</b> {row.is_terminal_specific_charge}</span><br></br>
          <span><b>Terminal:</b> {filter_data(allTerminalList, row.terminal, "terminal")}</span><br></br>
          <span><b>Event Type:</b> {row.event_type? row.event_type.replaceAll("_"," "):""}</span><br></br>
          <span><b>Event SUb-Type:</b> {row.event_sub_type? row.event_sub_type.replaceAll("_"," "):""}</span>
        </div>,
      sortable: true,
    },
    {
      name: 'Payable By',
      width: '110px',
      selector: row => row.payable_by,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("draftbooking:tariffcharge:delete")?
          <Button className="btn btn-sm bg-danger border-0 mx-2" title="Delete" onClick={() => handleDeleteBulkChargeModalOpen(row)}>
            <i className="fa fa-trash"></i>
          </Button>
          :
          ""
        }
      </div>,
    }
  ];

  const handleDeleteBulkChargeModalOpen = (data) => {
    setShowDeleteBulkChargeModal(true)
    setBulkRecordForDelete(data)
  }

  const deleteSelectedRecordFromBulk = (data) => {
    setShowDeleteBulkLoader(true)

    const filtered_data = bulkUploadChargesData.filter(tariff => !(tariff.charge_name == data.charge_name && 
                                                                  tariff.charge_type == data.charge_type &&
                                                                  tariff.charge_category == data.charge_category &&
                                                                  tariff.product == data.product &&
                                                                  tariff.port == data.port && 
                                                                  tariff.agent == data.agent && 
                                                                  tariff.vendor == data.vendor &&
                                                                  tariff.terminal == data.terminal
                                                                ));
    
    setBulkUploadChargesData(filtered_data)
    setShowDeleteBulkLoader(false)
    setShowDeleteBulkChargeModal(false)
  }

  const removeSelectedTariffCharges = (selcteddata) => {
    setShowDeleteSelectedBulkLoader(true)
    const filtered_data = bulkUploadChargesData.filter((tariff) =>
                                                    !selcteddata.some((selected) =>
                                                                        selected.charge_name === tariff.charge_name &&
                                                                        selected.charge_type === tariff.charge_type &&
                                                                        selected.charge_category === tariff.charge_category &&
                                                                        selected.product === tariff.product &&
                                                                        selected.port === tariff.port &&
                                                                        selected.agent === tariff.agent &&
                                                                        selected.vendor === tariff.vendor &&
                                                                        (selected.terminal ? selected.terminal === tariff.terminal : true)
                                                    )
                                                );

    setBulkUploadChargesData(filtered_data)
    if(filtered_data.length<1){
      setSelectedTariffCharges([])
      setBulkUploadFile(null)
      setUploadFileKey(Date.now());
      setShowBulkUploadModal(false)
    }
    
    setShowDeleteSelectedBulkLoader(false)
  }

  const handleTariffExcelFormat = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Tariff Data');

    worksheet.columns = [
      { header: 'port', key: 'port', width: 30 },
      { header: 'agent', key: 'agent', width: 25 },
      { header: 'vendor', key: 'vendor', width: 20 },
      { header: 'product', key: 'product', width: 15 },
      { header: 'charge_name', key: 'charge_name', width: 30 },
      { header: 'charge_category', key: 'charge_category', width: 15 },
      { header: 'charge_basis', key: 'charge_basis', width: 15 },
      { header: 'charge_type', key: 'charge_type', width: 15 },
      { header: 'currency', key: 'currency', width: 15 },
      { header: 'amount', key: 'amount', width: 15 },
      { header: 'amount_type', key: 'amount_type', width: 15 },
      { header: 'expense', key: 'expense', width: 15 },
      { header: 'event_type', key: 'event_type', width: 35 },
      { header: 'event_sub_type', key: 'event_sub_type', width: 35 },
      { header: 'applicable_for', key: 'applicable_for', width: 15 },
      { header: 'is_terminal_specific_charge', key: 'is_terminal_specific_charge', width: 30 },
      { header: 'terminal', key: 'terminal', width: 30 },
      { header: 'is_mandatory_charge', key: 'is_mandatory_charge', width: 20 },
      { header: 'payable_by', key: 'payable_by', width: 15 },
      { header: 'valid_from', key: 'valid_from', width: 15 },
      { header: 'valid_to', key: 'valid_to', width: 15 },
      { header: 'remarks', key: 'remarks', width: 15 },
      { header: 'is_active', key: 'active', width: 15 },
    ];

    worksheet.dataValidations.add('D2:D1000', {
      type: 'list',
      allowBlank: true,
      formulae: ['"20FR,20GP,20HD,20OT,20TK,40FR,40GP,40HC,40OT,BL,ISOTANK,OTHER,TAX"'],
      showErrorMessage: true,
      errorTitle: 'Invalid Input',
      error: 'Please select a valid product.'
    });

    worksheet.dataValidations.add('F2:F1000', {
      type: 'list',
      allowBlank: true,
      formulae: ['"FREIGHT,EXPORT_LOCAL,IMPORT_LOCAL,SURCHARGE,DOCUMENTATION,CUSTOM,OTHER"'],
      showErrorMessage: true,
      errorTitle: 'Invalid Input',
      error: 'Please select a valid category.'
    });

    worksheet.dataValidations.add('G2:G1000', {
      type: 'list',
      allowBlank: true,
      formulae: ['"PER_CONTAINER,PER_CBM,PER_KG,FLAT,PER_SHIPMENT,PER_BILL,BY_WEIGHT_LIMIT"'],
      showErrorMessage: true,
      errorTitle: 'Invalid Input',
      error: 'Please select a valid basis.'
    });

    worksheet.dataValidations.add('H2:H1000', {
      type: 'list',
      allowBlank: true,
      formulae: ['"HAZARDOUS,NON_HAZARDOUS,MIX_HAZARDOUS"'],
      showErrorMessage: true,
      errorTitle: 'Invalid Input',
      error: 'Please select a valid category.'
    });

    worksheet.dataValidations.add('K2:K1000', {
      type: 'list',
      allowBlank: true,
      formulae: ['"AMOUNT,PERCENTAGE"'],
      showErrorMessage: true,
      errorTitle: 'Invalid Input',
      error: 'Please select a valid type.'
    });

    worksheet.dataValidations.add('M2:M1000', {
      type: 'list',
      allowBlank: true,
      formulae: ['"EXPORT_PAYABLE,EXPORT_RECEIVABLE,IMPORT_PAYABLE,IMPORT_RECEIVABLE,RAIL_TO_SEA_TSP_EXPORT_PAYABLE,RAIL_TO_SEA_TSP_IMPORT_PAYABLE,SEA_TO_RAIL_TSP_EXPORT_PAYABLE,SEA_TO_RAIL_TSP_IMPORT_PAYABLE,SEA_TO_SEA_TSP_EXPORT_PAYABLE,SEA_TO_SEA_TSP_IMPORT_PAYABLE,NONE"'],
      showErrorMessage: true,
      errorTitle: 'Invalid Input',
      error: 'Please select a valid event type.'
    });

    worksheet.dataValidations.add('N2:N1000', {
      type: 'list',
      allowBlank: true,
      formulae: ['"ALL_CONTAINERS_PICKED,BL_MARKED_EXPRESS,BL_MARKED_SEAWAY,BL_SURRENDERED,CERTIFICATE_ISSUED,REACHED_FD,REACHED_TSP,SHIPPED_ON_BOARD,SOB_FROM_TSP,NONE"'],
      showErrorMessage: true,
      errorTitle: 'Invalid Input',
      error: 'Please select a valid event sub type.'
    });

    worksheet.dataValidations.add('O2:O1000', {
      type: 'list',
      allowBlank: true,
      formulae: ['"POA,POL,POD,FD,TSP,NONE"'],
      showErrorMessage: true,
      errorTitle: 'Invalid Input',
      error: 'Please select a valid option.'
    });

    worksheet.dataValidations.add('P2:P1000', {
      type: 'list',
      allowBlank: true,
      formulae: ['"YES,NO"'],
      showErrorMessage: true,
      errorTitle: 'Invalid Input',
      error: 'Please select a valid category.'
    });

    worksheet.dataValidations.add('R2:R1000', {
      type: 'list',
      allowBlank: true,
      formulae: ['"YES,NO"'],
      showErrorMessage: true,
      errorTitle: 'Invalid Input',
      error: 'Please select a valid option.'
    });

    worksheet.dataValidations.add('S2:S1000', {
      type: 'list',
      allowBlank: true,
      formulae: ['"SHIPPER,CONSIGNEE,AGENT,LINE,CUSTOMER,THIRD_PARTY"'],
      showErrorMessage: true,
      errorTitle: 'Invalid Input',
      error: 'Please select a valid payer.'
    });

    worksheet.dataValidations.add('W2:W1000', {
      type: 'list',
      allowBlank: true,
      formulae: ['"YES,NO"'],
      showErrorMessage: true,
      errorTitle: 'Invalid Input',
      error: 'Please select a valid status.'
    });

    worksheet.dataValidations.add('T2:T1000', {
      type: 'date',
      operator: 'between',
      formulae: ['DATE(2000,12,12)', 'DATE(2099,12,31)'],
      showErrorMessage: false,
      errorTitle: 'Invalid Date',
      error: 'Please enter a valid date (YYYY-MM-DD).',
    });

    worksheet.dataValidations.add('U2:U1000', {
      type: 'date',
      operator: 'between',
      formulae: ['DATE(2000,1,1)', 'DATE(2099,12,31)'],
      showErrorMessage: false,
      errorTitle: 'Invalid Date',
      error: 'Please enter a valid date (YYYY-MM-DD).',
    });

    worksheet.getColumn('T').numFmt = 'yyyy-mm-dd';
    worksheet.getColumn('U').numFmt = 'yyyy-mm-dd';

    // Sheet 2: Reference Data (Dropdown Source)
    const refSheet = workbook.addWorksheet('ReferenceData');
    const portList = bulkPortList
    const terminalList = bulkTerminalList
    const vendorList = bulkVendorList
    const agentList = bulkAgentList
    const currencyList = bulkCurrencyList
    
    portList.forEach((port, i) => { refSheet.getCell(`A${i + 2}`).value = port });
    terminalList.forEach((terminal, i) => { refSheet.getCell(`Q${i + 2}`).value = terminal });
    vendorList.forEach((vendor, i) => { refSheet.getCell(`C${i + 2}`).value = vendor });
    agentList.forEach((agent, i) => { refSheet.getCell(`B${i + 2}`).value = agent });
    currencyList.forEach((currency, i) => { refSheet.getCell(`I${i + 2}`).value = currency });

    worksheet.dataValidations.add('A2:A1000', {
      type: 'list',
      allowBlank: false,
      formulae: [`=ReferenceData!$A$2:$A$${portList.length+1}`],
      showErrorMessage: true,
      errorTitle: 'Invalid Port',
      error: 'Please select a port from the list.',
    });

    worksheet.dataValidations.add('Q2:Q1000', {
      type: 'list',
      allowBlank: true,
      formulae: [`=ReferenceData!$Q$2:$Q$${terminalList.length+1}`],
      showErrorMessage: true,
      errorTitle: 'Invalid Terminal',
      error: 'Please select a terminal from the list.',
    });

    worksheet.dataValidations.add('C2:C1000', {
      type: 'list',
      allowBlank: true,
      formulae: [`=ReferenceData!$C$2:$C$${vendorList.length+1}`],
      showErrorMessage: true,
      errorTitle: 'Invalid Vendor',
      error: 'Please select a vendor from the list.',
    });

    worksheet.dataValidations.add('B2:B1000', {
      type: 'list',
      allowBlank: true,
      formulae: [`=ReferenceData!$B$2:$B$${agentList.length+1}`],
      showErrorMessage: true,
      errorTitle: 'Invalid Agent',
      error: 'Please select a agent from the list.',
    });

    worksheet.dataValidations.add('I2:I1000', {
      type: 'list',
      allowBlank: true,
      formulae: [`=ReferenceData!$I$2:$I$${currencyList.length+1}`],
      showErrorMessage: true,
      errorTitle: 'Invalid Currency',
      error: 'Please select a currency from the list.',
    });

    // Create buffer and save
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    saveAs(blob, 'TariffData.xlsx');
  };

  const handleBulkUploadModalClose = () => {
    setShowBulkUploadModal(false)
    setBulkUploadFile(null);
    setSelectedTariffCharges([])
    setBulkUploadChargesData([]);
  }

  const handleBulkUploadChange = (file) => {
    setBulkUploadDataPending(true)
    setBulkUploadFile(file);
    const file_data = file
    const reader = new FileReader();

    reader.onload = (event) => {
        const excel_data = event.target.result
        const workbook = XLSX.read(excel_data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const sheetData = XLSX.utils.sheet_to_json(sheet);
        setBulkUploadChargesData(sheetData);
    };

    reader.readAsArrayBuffer(file_data);
    setBulkUploadDataPending(false)
  };

  const bulkUploadTariffCharges = async () => {
    setShowBulkUploadLoader(true)
    try {
      const bulk_data = {"charges": selectedTariffCharges.length>0?selectedTariffCharges:bulkUploadChargesData, "created_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})}

      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/tariffcharge/bulkupload/', bulk_data, {
        headers: {
            "Content-Type": "application/json",
        }
      });

      if (response.status == 200) {
        getTariffCharges()
        toast.success("Tariff Charges Uploaded SUccessfully.");
      }

    } catch (err) {
        toast.error("Error in uploading bulk data! Try again.");
    }
    setShowBulkUploadLoader(false)
    setShowBulkUploadModal(false)
  }


  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
      <ToastContainer></ToastContainer>
      <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true} sendDataToParent={handleDataFromTopNavBar}/>
      <SideNavbar sidebarCollapsed={menuDrawerShow} activeMenu="DraftBooking" activeSubMenu="ManageTariff" activeSubMenuLevel1="TariffCharge" permissionFromTopNavbar={dataFromTopNavBar}/>

      <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"} >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                {menuDrawerShow?
                  <span><i className="fa fa-chevron-left mx-1"></i></span>:
                  <span><i className="fa fa-chevron-right mx-1"></i></span>
                }
              </Button>
              <span className="page-header-text">Tariff Charges</span>
            </div>

            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {
                currentUserRolePermissionData?.includes("draftbooking:tariffcharge:add")?
                  <Button className="btn btn-sm border-0 px-3 float-right ml-2 btn-success" onClick={() => [setShowBulkUploadModal(true), setBulkUploadFile(null), setBulkUploadChargesData([])]} title="Bulk Upload">
                    <i className="fa fa-upload fa-lg text-right"></i>
                  </Button>
                :
                  ""
              }

              {
                currentUserRolePermissionData?.includes("draftbooking:tariffcharge:add")?
                  <Button className="btn btn-sm btn-inox-green border-0  px-3 float-right" data-bs-toggle="offcanvas" data-bs-target="#addSection">
                    <i className="fa fa-plus fa-lg text-right" style={{ paddingRight: 10 }}></i>
                    <span className="fw-bold">Add Tariff Charge</span>
                  </Button>
                :
                  ""
              }

              {!showSearchForm?
              <Button className="btn btn-sm btn-inox-green border-0 float-right mx-2" onClick={() => setShowSearchForm(!showSearchForm)}>
                <i className="fa fa-search fa-sm text-right"></i>
              </Button>
              :""}
            </div>
          </div>
        </div>

        {showSearchForm?
        <div className="col-12 text-left" style={{ paddingTop: 5, paddingBottom: 5, paddingLeft: 20, paddingRight: 30, zIndex: 1000 }}>
          <form ref={searchform} onSubmit={(e) => searchTariffCharge(e)}>
            <div className="row mb-2">
              <div className="col-2">
                <input type="text" className="form form-control form-control-sm border-secondary" name="search_charge_name" placeholder="Enter Charge Name"></input>
              </div>

              <div className="col-2">
                <Select 
                  options={filterPortList} 
                  id="search_charge_port" 
                  name="search_charge_port"
                  isMulti={false}
                  isClearable
                  className="px-0"
                  placeholder="Select Port"
                  styles={FilterFormSelectCustomStyles}
                />
              </div>

              <div className="col-2">
                <Select 
                  options={filterProductList} 
                  id="search_container_type" 
                  name="search_container_type"
                  isMulti={false}
                  isClearable
                  className="px-0"
                  placeholder="Container"
                  styles={FilterFormSelectCustomStyles}
                />
              </div>

              <div className="col-2">
                <Select 
                  options={filterAgentList} 
                  id="search_charge_agent" 
                  name="search_charge_agent"
                  isMulti={false}
                  isClearable
                  className="px-0"
                  placeholder="Agent"
                  styles={FilterFormSelectCustomStyles}
                />
              </div>

              <div className="col-2">
                <Select 
                  options={filterVendorList} 
                  id="search_charge_vendor" 
                  name="search_charge_vendor"
                  isMulti={false}
                  isClearable
                  className="px-0"
                  placeholder="Vendor"
                  styles={FilterFormSelectCustomStyles}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-2">
                <select className="form form-select form-select-sm border-secondary" name="search_charge_category">
                  <option value="">Select Charge Category</option>
                  <option value="FREIGHT">FREIGHT</option>
                  <option value="EXPORT_LOCAL">EXPORT LOCAL</option>
                  <option value="IMPORT_LOCAL">IMPORT LOCAL</option>
                  <option value="SURCHARGE">SURCHARGE</option>
                  <option value="DOCUMENTATION">DOCUMENTATION</option>
                  <option value="CUSTOM">CUSTOM</option>
                  <option value="OTHER">OTHER</option>
                </select>
              </div>

              <div className="col-2">
                <select className="form form-select form-select-sm border-secondary" name="search_charge_basis">
                  <option value="">Select Charge Basis</option>
                  <option value="PER_CONTAINER">PER_CONTAINER</option>
                  <option value="PER_CBM">PER CBM</option>
                  <option value="PER_KG">PER KG</option>
                  <option value="FLAT">FLAT</option>
                  <option value="PER_SHIPMENT">PER SHIPMENT</option>
                  <option value="PER_BILL">PER BILL</option>
                  <option value="BY_WEIGHT_LIMIT">BY WEIGHT LIMIT</option>
                </select>
              </div>

              <div className="col-2">
                <select className="form form-select form-select-sm border-secondary" name="search_charge_type">
                  <option value="">Charge Type</option>
                  <option value="HAZARDOUS">HAZARDOUS</option>
                  <option value="NON_HAZARDOUS">NON HAZARDOUS</option>
                  <option value="MIX_HAZARDOUS">MIX HAZARDOUS</option>
                  <option value="EMPTY">EMPTY</option>
                </select>
              </div>

              <div className="col-2">
                <select className="form form-select form-select-sm border-secondary" name="search_charge_event_type">
                  <option value="NONE">Event Type</option>
                  <option value="EXPORT_PAYABLE">EXPORT PAYABLE</option>
                  <option value="EXPORT_RECEIVABLE">EXPORT RECEIVABLE</option>
                  <option value="IMPORT_PAYABLE">IMPORT PAYABLE</option>
                  <option value="IMPORT_RECEIVABLE">IMPORT RECEIVABLE</option>
                  <option value="RAIL_TO_SEA_TSP_EXPORT_PAYABLE">RAIL TO SEA TSP EXPORT PAYABLE</option>
                  <option value="RAIL_TO_SEA_TSP_IMPORT_PAYABLE">RAIL TO SEA TSP IMPORT PAYABLE</option>
                  <option value="SEA_TO_RAIL_TSP_EXPORT_PAYABLE">SEA TO RAIL TSP EXPORT PAYABLE</option>
                  <option value="SEA_TO_RAIL_TSP_IMPORT_PAYABLE">SEA TO RAIL TSP IMPORT PAYABLE</option>
                  <option value="SEA_TO_SEA_TSP_EXPORT_PAYABLE">SEA TO SEA TSP EXPORT PAYABLE</option>
                  <option value="SEA_TO_SEA_TSP_IMPORT_PAYABLE">SEA TO SEA TSP IMPORT PAYABLE</option>
                </select>
              </div>

              <div className="col-2">
                <select className="form form-select form-select-sm border-secondary" name="search_charge_event_sub_type">
                  <option value="NONE">Event Sub Type</option>
                  <option value="ALL_CONTAINERS_PICKED">ALL CONTAINERS PICKED</option>
                  <option value="BL_MARKED_EXPRESS">BL MARKED EXPRESS</option>
                  <option value="BL_MARKED_SEAWAY">BL MARKED SEAWAY</option>
                  <option value="BL_SURRENDERED">BL SURRENDERED</option>
                  <option value="CERTIFICATE_ISSUED">CERTIFICATE ISSUED</option>
                  <option value="REACHED_FD">REACHED FD</option>
                  <option value="REACHED_TSP">REACHED TSP</option>
                  <option value="SHIPPED_ON_BOARD">SHIPPED ON BOARD</option>
                  <option value="SOB_FROM_TSP">SOB FROM TSP</option>
                </select>
              </div>

              <div className="col-2">
                <Button className="btn btn-inox-green border btn-sm px-3" onClick={(e) => searchTariffCharge(e)}>Search</Button>
                <Button className="btn btn-secondary border btn-sm mx-1" onClick={() => setShowSearchForm(!showSearchForm)}>
                  <i className="fa fa-times"></i>
                </Button>
                <span className="px-2 pointer" 
                      style={{ verticalAlign: 'middle'}} 
                      onClick={() => [
                        searchform.current.search_charge_name.value = "",
                        searchform.current.search_charge_port.value = "",
                        searchform.current.search_charge_agent.value = "",
                        searchform.current.search_charge_vendor.value = "",
                        searchform.current.search_container_type.value = "",
                        searchform.current.search_charge_category.value = "",
                        searchform.current.search_charge_basis.value = "",
                        searchform.current.search_charge_type.value = "",
                        searchform.current.search_charge_event_type.value = "",
                        searchform.current.search_charge_event_sub_type.value = "",
                        getTariffCharges()
                      ]}>
                  Clear Filters
                </span>
              </div>
            </div>
          </form>
        </div>
        :
        ""}

        <div className="col-12 text-left" style={{ marginTop: -5, paddingLeft: 20, paddingRight: 30, zIndex: 100 }}>
          <DataTable
            columns={tariffchargecolumns}
            data={tariffChargeList}
            progressPending={chargeDataPending}
            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true"/>}
            noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
            pagination
            highlightOnHover
            fixedHeader
            customStyles={tariffChargeTableCustomStyles}
            dense
          />
        </div>
      </div>

      <Modal size="sm" show={showDeleteModal} onHide={handleDeleteModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>Close</Button>
          <Button variant="danger" onClick={()=> deleteSelectedRecord(recordForDelete?.id)}>
            {showDeleteLoader?
            <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
            :
            "Delete"
            }
            
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal size="xl" show={showBulkUploadModal} onHide={handleBulkUploadModalClose} fullscreen centered>
        <Modal.Header closeButton>
          <Modal.Title>Bulk Upload Tariff Charges</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-5">
              <FileUploader key={uploadFileKey} handleChange={handleBulkUploadChange} name="tariff_charges_file" types={fileTypes} multiple={false}/>
            </div>

            <div className="col-6">
              {bulkUploadFile ?
                <div className="text-left" key={bulkUploadFile?.name}>
                    <p className="mb-0"><b>File Name:</b> {bulkUploadFile?.name}</p>
                    <span><b>Size:</b> {(bulkUploadFile?.size * 0.001).toFixed(3)} Kb</span>
                </div>
                : ""}
            </div>

            <div className="col-1">
              <i className="fa fa-file-excel-o text-white float-right bg-success p-2 rounded cursor-pointer" title="Download Format" onClick={() => handleTariffExcelFormat()}></i>
            </div>

            <div className="col-12">
              {selectedTariffCharges.length>0?
                <Button className="btn btn-danger btn-sm mt-2" onClick={() => removeSelectedTariffCharges(selectedTariffCharges)}>
                  {showDeleteSelectedBulkLoader?
                  <Spinner className="mx-5 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                  :
                  "Remove Selected"
                  }
                </Button>
              :
                ""
              }
            </div>

            <div className="col-12">
              <DataTable
                columns={bulkuploadcolumns}
                data={bulkUploadChargesData}
                progressPending={bulkUploadDataPending}
                progressComponent={<div className="concorde-loader table-no-data"></div>}
                noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
                pagination
                highlightOnHover
                fixedHeader
                isSearchable
                dense
                customStyles={tariffChargeBulkTableCustomStyles}
                conditionalRowStyles={tariffChargeBulkConditionalRowCustomStyles}
                selectableRows={true}
                onSelectedRowsChange={(e) => [setSelectedTariffCharges(e?.selectedRows), console.log("))))))))", e?.selectedRows)]}
              />
            </div>
        </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleBulkUploadModalClose}>Close</Button>
          <Button variant="success" onClick={()=> bulkUploadTariffCharges()}>
            {showBulkUploadLoader?
            <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
            :
            "Upload"
            }
            
          </Button>
        </Modal.Footer>
      </Modal>


      <Modal size="md" show={showDeleteBulkChargeModal} onHide={() => setShowDeleteBulkChargeModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Remove</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to remove this charge from bulk upload?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteBulkChargeModal(false)}>Close</Button>
          <Button variant="danger" onClick={()=> deleteSelectedRecordFromBulk(bulkRecordForDelete)}>
            {showDeleteBulkLoader?
            <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
            :
            "Delete"
            }
            
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Section ------------------- */}
      <div class={canvasFullScreen && showUpdateCanvas?"offcanvas offcanvas-bottom h-100 show":
        !canvasFullScreen && showUpdateCanvas?"offcanvas offcanvas-bottom h-60 show":"offcanvas offcanvas-bottom h-60"} 
        id="updateSection" data-bs-scroll="true" tabindex="-1" aria-labelledby="offcanvasBottomLabel">
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">Update Record</h4>
            </div>
            <div className="col-6">
              <button type="button" class="btn btn-danger btn-sm float-right" data-bs-dismiss="offcanvas" aria-label="Close" title="Close"
              onClick={() => [setShowUpdateCanvas(false)]}>
                  <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen?
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Half Screen" onClick={() => [setCanvasFullScreen(false), setShowUpdateCanvas(true)]}>
                    <i className="fa fa-window-minimize text-white"></i>
                </button>
                :
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Full Screen" onClick={() => [setCanvasFullScreen(true), setShowUpdateCanvas(true)]}>
                    <i className="fa fa-window-maximize text-white"></i>
                </button>
              }
            </div>
          </div>
        </div>

        <div class="offcanvas-body" style={{ paddingLeft: 20, paddingRight: 40 }}>
          <form onSubmit={(e) => updateTariffCharge(e)}>
            <div className="row">
              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="vendor">Vendor: <i className="text-danger">*</i><span className="text-danger">{showUpdateVendorError ? " Vendor required" : ""}</span></label>
                <Select 
                  options={vendorList} 
                  id="vendor" 
                  name="vendor"
                  isMulti={false}
                  isClearable
                  className="px-0"
                  placeholder="Select Vendor"
                  styles={smallFormSelectCustomStyles}
                  onChange={(e) => setUpdateChargeVendor(e)}
                  onBlur={(e) => e?.value == "" ? setShowUpdateVendorError(true) : setShowUpdateVendorError(false)}
                  value={updateChargeVendor}
                />
              </div>
              
              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="agent">Agent: <i className="text-danger">*</i><span className="text-danger">{showUpdateAgentError ? " Agent required" : ""}</span></label>
                <Select 
                  options={agentList} 
                  id="agent" 
                  name="agent"
                  isMulti={false}
                  isClearable
                  className="px-0"
                  placeholder="Select Agent"
                  styles={smallFormSelectCustomStyles}
                  onChange={(e) => setUpdateChargeAgent(e)}
                  onBlur={(e) => e?.value == "" ? setShowUpdateAgentError(true) : setShowUpdateAgentError(false)}
                  value={updateChargeAgent}
                />
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="port">Port: <i className="text-danger">*</i><span className="text-danger">{showUpdatePortError ? " Port required" : ""}</span></label>
                <Select 
                  options={portList} 
                  id="port" 
                  name="port"
                  isMulti={false}
                  isClearable
                  className="px-0"
                  placeholder="Select Port"
                  styles={smallFormSelectCustomStyles}
                  onChange={(e) => [setUpdateChargePort(e), getTerminal(e?.value)]}
                  onBlur={(e) => e?.value == "" ? setShowUpdatePortError(true) : setShowUpdatePortError(false)}
                  value={updateChargePort}
                />
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="charge_name">Charge Name: <i className="text-danger">*</i><span className="text-danger">{showUpdateChargeNameError ? " Charge Name required" : ""}</span></label>
                <input type="text" class="form-control form-control-sm" id="charge_name" name="charge_name" placeholder="Enter Charge Name" onChange={(e) => setUpdateChargeName(e.target.value)}
                  value={updateChargeName} onBlur={(e) => e.target.value == "" ? setShowUpdateChargeNameError(true) : setShowUpdateChargeNameError(false)} />
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="product">Product: <i className="text-danger">*</i><span className="text-danger">{showUpdateProductError ? " Product required" : ""}</span></label>
                <select className="form-select form-select-sm" name="product" onChange={(e) => setUpdateChargeProduct(e.target.value)}
                  onBlur={(e) => e.target.value == "" ? setShowUpdateProductError(true) : setShowUpdateProductError(false)}>
                  <option value="" selected>Select Product</option>
                  {productList.map(product => 
                    <option value={product.id} selected={updateChargeProduct==product.id?true:false}>{product.product_name}</option>
                  )}
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="charge_type">Type: <i className="text-danger">*</i><span className="text-danger">{showUpdateChargeTypeError ? " Type required" : ""}</span></label>
                <select className="form-select form-select-sm" name="charge_type" onChange={(e) => setUpdateChargeType(e.target.value)}
                  onBlur={(e) => e.target.value == "" ? setShowUpdateChargeTypeError(true) : setShowUpdateChargeTypeError(false)}>
                  <option value="" selected>Select Type</option>
                  <option value="HAZARDOUS" selected={updateChargeType=="HAZARDOUS"?true:false}>HAZARDOUS</option>
                  <option value="NON_HAZARDOUS" selected={updateChargeType=="NON_HAZARDOUS"?true:false}>NON HAZARDOUS</option>
                  <option value="MIX_HAZARDOUS" selected={updateChargeType=="MIX_HAZARDOUS"?true:false}>MIX HAZARDOUS</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="charge_category">Category: <i className="text-danger">*</i><span className="text-danger">{showUpdateChargeCategoryError ? " Category required" : ""}</span></label>
                <select className="form-select form-select-sm" name="charge_category" onChange={(e) => setUpdateChargeCategory(e.target.value)}
                  onBlur={(e) => e.target.value == "" ? setShowUpdateChargeCategoryError(true) : setShowUpdateChargeCategoryError(false)}>
                  <option value="" selected>Select Category</option>
                  <option value="FREIGHT" selected={updateChargeCategory=="FREIGHT"?true:false}>FREIGHT</option>
                  <option value="EXPORT_LOCAL" selected={updateChargeCategory=="EXPORT_LOCAL"?true:false}>EXPORT LOCAL</option>
                  <option value="IMPORT_LOCAL" selected={updateChargeCategory=="IMPORT_LOCAL"?true:false}>IMPORT LOCAL</option>
                  <option value="SURCHARGE" selected={updateChargeCategory=="SURCHARGE"?true:false}>SURCHARGE</option>
                  <option value="DOCUMENTATION" selected={updateChargeCategory=="DOCUMENTATION"?true:false}>DOCUMENTATION</option>
                  <option value="CUSTOM" selected={updateChargeCategory=="CUSTOM"?true:false}>CUSTOM</option>
                  <option value="OTHER" selected={updateChargeCategory=="OTHER"?true:false}>OTHER</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="charge_basis">Basis: <i className="text-danger">*</i><span className="text-danger">{showUpdateChargeBasisError ? " Basis required" : ""}</span></label>
                <select className="form-select form-select-sm" name="charge_basis" onChange={(e) => setUpdateChargeBasis(e.target.value)}
                  onBlur={(e) => e.target.value == "" ? setShowUpdateChargeBasisError(true) : setShowUpdateChargeBasisError(false)}>
                  <option value="" selected>Select Basis</option>
                  <option value="PER_CONTAINER" selected={updateChargeBasis=="PER_CONTAINER"?true:false}>PER CONTAINER</option>
                  <option value="PER_CBM" selected={updateChargeBasis=="PER_CBM"?true:false}>PER CBM</option>
                  <option value="PER_KG" selected={updateChargeBasis=="PER_KG"?true:false}>PER KG</option>
                  <option value="FLAT" selected={updateChargeBasis=="FLAT"?true:false}>FLAT</option>
                  <option value="PER_SHIPMENT" selected={updateChargeBasis=="PER_SHIPMENT"?true:false}>PER SHIPMENT</option>
                  <option value="PER_BILL" selected={updateChargeBasis=="PER_BILL"?true:false}>PER BILL</option>
                  <option value="BY_WEIGHT_LIMIT" selected={updateChargeBasis=="BY_WEIGHT_LIMIT"?true:false}>BY WEIGHT LIMIT</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="amount">Amount: <i className="text-danger">*</i><span className="text-danger">{showUpdateAmountError ? " Amount required" : ""}</span></label>
                <input type="text" class="form-control form-control-sm" id="amount" name="amount" placeholder="Enter Amount" onChange={(e) => setUpdateChargeAmount(e.target.value)}
                  value={updateChargeAmount} onBlur={(e) => e.target.value == "" ? setShowUpdateAmountError(true) : setShowUpdateAmountError(false)} />
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="amount_type">Amount Type: <i className="text-danger">*</i><span className="text-danger">{showUpdateAmountTypeError ? " Type required" : ""}</span></label>
                <select className="form-select form-select-sm" name="amount_type" onChange={(e) => setUpdateChargeAmountType(e.target.value)}
                  onBlur={(e) => e.target.value == "" ? setShowUpdateAmountTypeError(true) : setShowUpdateAmountTypeError(false)}>
                  <option value="" selected>Select Type</option>
                  <option value="AMOUNT" selected={updateChargeAmountType=="AMOUNT"?true:false}>AMOUNT</option>
                  <option value="PERCENTAGE" selected={updateChargeAmountType=="PERCENTAGE"?true:false}>PERCENTAGE</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="expense">Expense: <i className="text-danger">*</i><span className="text-danger">{showUpdateExpenseError ? " Expense required" : ""}</span></label>
                <input type="text" class="form-control form-control-sm" id="expense" name="expense" placeholder="Enter Expense" onChange={(e) => setUpdateChargeExpense(e.target.value)}
                  value={updateChargeExpense} onBlur={(e) => e.target.value == "" ? setShowUpdateExpenseError(true) : setShowUpdateExpenseError(false)} />
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="currency">Currency: <i className="text-danger">*</i><span className="text-danger">{showUpdateChargeCurrencyError ? " Currency required" : ""}</span></label>
                <select className="form-select form-select-sm" name="currency" onChange={(e) => setUpdateChargeCurrency(e.target.value)}
                  onBlur={(e) => e.target.value == "" ? setShowUpdateChargeCurrencyError(true) : setShowUpdateChargeCurrencyError(false)}>
                  <option value="" selected>Select Currency</option>
                  {currencyList.map(currency => 
                    <option value={currency.id} selected={updateChargeCurrency==currency.id?true:false}>{currency.name} ({currency.symbol})</option>
                  )}
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="is_terminal_specific">Is Terminal Specific? </label>
                <select className="form-select form-select-sm" name="is_terminal_specific" onChange={(e) => [setUpdateIsTerminalSpecificCharge(e.target.value), setUpdateChargeTerminal("")]}>
                  <option value={updateIsTerminalSpecificCharge} selected={updateIsTerminalSpecificCharge=="NO"?true:false}>NO</option>
                  <option value={updateIsTerminalSpecificCharge} selected={updateIsTerminalSpecificCharge=="YES"?true:false}>YES</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="terminal">Terminal: <i className="text-danger">*</i><span className="text-danger">{showUpdateTerminalError ? " Terminal required" : ""}</span></label>
                <select className="form-select form-select-sm" name="terminal" onChange={(e) => setUpdateChargeTerminal(e.target.value)} value={updateChargeTerminal}
                  onBlur={(e) => e.target.value == "" ? setShowTerminalError(true) : setShowTerminalError(false)} disabled={updateIsTerminalSpecificCharge=="NO"|updateIsTerminalSpecificCharge==""?true:false}>
                  <option value="" selected>Select Terminal</option>
                  {terminalList.map(terminal => 
                    <option value={terminal.id} selected={updateChargeTerminal==terminal.id?true:false}>{terminal.name}</option>
                  )}
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="applicable_for">Applicable For: <i className="text-danger">*</i><span className="text-danger">{showUpdateApplicableForError ? " Option required" : ""}</span></label>
                <select className="form-select form-select-sm" name="applicable_for" onChange={(e) => setUpdateApplicableFor(e.target.value)}
                  onBlur={(e) => e.target.value == "" ? setShowUpdateApplicableForError(true) : setShowUpdateApplicableForError(false)}>
                  <option value="" selected>Select Applicable For</option>
                  <option value="POA" selected={updateApplicableFor=="POA"?true:false}>POA</option>
                  <option value="POL" selected={updateApplicableFor=="POL"?true:false}>POL</option>
                  <option value="POD" selected={updateApplicableFor=="POD"?true:false}>POD</option>
                  <option value="FD" selected={updateApplicableFor=="FD"?true:false}>FD</option>
                  <option value="TSP" selected={updateApplicableFor=="TSP"?true:false}>TSP</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="event_type">Event Type: </label>
                <select className="form-select form-select-sm" name="event_type" onChange={(e) => setUpdateChargeEventType(e.target.value)}>
                  <option value="NONE" selected>Select Event Type</option>
                  <option value="EXPORT_PAYABLE" selected={updateChargeEventType=="EXPORT_PAYABLE"?true:false}>EXPORT PAYABLE</option>
                  <option value="EXPORT_RECEIVABLE" selected={updateChargeEventType=="EXPORT_RECEIVABLE"?true:false}>EXPORT RECEIVABLE</option>
                  <option value="IMPORT_PAYABLE" selected={updateChargeEventType=="IMPORT_PAYABLE"?true:false}>IMPORT PAYABLE</option>
                  <option value="IMPORT_RECEIVABLE" selected={updateChargeEventType=="IMPORT_RECEIVABLE"?true:false}>IMPORT RECEIVABLE</option>
                  <option value="RAIL_TO_SEA_TSP_EXPORT_PAYABLE" selected={updateChargeEventType=="RAIL_TO_SEA_TSP_EXPORT_PAYABLE"?true:false}>RAIL TO SEA TSP EXPORT PAYABLE</option>
                  <option value="RAIL_TO_SEA_TSP_IMPORT_PAYABLE" selected={updateChargeEventType=="RAIL_TO_SEA_TSP_IMPORT_PAYABLE"?true:false}>RAIL TO SEA TSP IMPORT PAYABLE</option>
                  <option value="SEA_TO_RAIL_TSP_EXPORT_PAYABLE" selected={updateChargeEventType=="SEA_TO_RAIL_TSP_EXPORT_PAYABLE"?true:false}>SEA TO RAIL TSP EXPORT PAYABLE</option>
                  <option value="SEA_TO_RAIL_TSP_IMPORT_PAYABLE" selected={updateChargeEventType=="SEA_TO_RAIL_TSP_IMPORT_PAYABLE"?true:false}>SEA TO RAIL TSP IMPORT PAYABLE</option>
                  <option value="SEA_TO_SEA_TSP_EXPORT_PAYABLE" selected={updateChargeEventType=="SEA_TO_SEA_TSP_EXPORT_PAYABLE"?true:false}>SEA TO SEA TSP EXPORT PAYABLE</option>
                  <option value="SEA_TO_SEA_TSP_IMPORT_PAYABLE" selected={updateChargeEventType=="SEA_TO_SEA_TSP_IMPORT_PAYABLE"?true:false}>SEA TO SEA TSP IMPORT PAYABLE</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="event_sub_type">Event Sub Type: </label>
                <select className="form-select form-select-sm" name="event_sub_type" onChange={(e) => setUpdateChargeEventSubType(e.target.value)}>
                  <option value="NONE" selected>Select Event Sub Type</option>
                  <option value="ALL_CONTAINERS_PICKED" selected={updateChargeEventSubType=="ALL_CONTAINERS_PICKED"?true:false}>ALL CONTAINERS PICKED</option>
                  <option value="BL_MARKED_EXPRESS" selected={updateChargeEventSubType=="BL_MARKED_EXPRESS"?true:false}>BL MARKED EXPRESS</option>
                  <option value="BL_MARKED_SEAWAY" selected={updateChargeEventSubType=="BL_MARKED_SEAWAY"?true:false}>BL MARKED SEAWAY</option>
                  <option value="BL_SURRENDERED" selected={updateChargeEventSubType=="BL_SURRENDERED"?true:false}>BL SURRENDERED</option>
                  <option value="CERTIFICATE_ISSUED" selected={updateChargeEventSubType=="CERTIFICATE_ISSUED"?true:false}>CERTIFICATE ISSUED</option>
                  <option value="REACHED_FD" selected={updateChargeEventSubType=="REACHED_FD"?true:false}>REACHED FD</option>
                  <option value="REACHED_TSP" selected={updateChargeEventSubType=="REACHED_TSP"?true:false}>REACHED TSP</option>
                  <option value="SHIPPED_ON_BOARD" selected={updateChargeEventSubType=="SHIPPED_ON_BOARD"?true:false}>SHIPPED ON BOARD</option>
                  <option value="SOB_FROM_TSP" selected={updateChargeEventSubType=="SOB_FROM_TSP"?true:false}>SOB FROM TSP</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="payable_by">Payable By </label>
                <select className="form-select form-select-sm" name="payable_by" onChange={(e) => setUpdateChargePayableBy(e.target.value)}>
                  <option value="SHIPPER" selected={updateChargePayableBy=="SHIPPER"?true:false}>SHIPPER</option>
                  <option value="CONSIGNEE" selected={updateChargePayableBy=="CONSIGNEE"?true:false}>CONSIGNEE</option>
                  <option value="AGENT" selected={updateChargePayableBy=="AGENT"?true:false}>AGENT</option>
                  <option value="LINE" selected={updateChargePayableBy=="LINE"?true:false}>LINE</option>
                  <option value="CUSTOMER" selected={updateChargePayableBy=="CUSTOMER"?true:false}>CUSTOMER</option>
                  <option value="THIRD_PARTY" selected={updateChargePayableBy=="THIRD_PARTY"?true:false}>THIRD PARTY</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="valid_from">Valid From: <i className="text-danger">*</i><span className="text-danger">{showUpdateValidFromError ? " Date required" : ""}</span></label>
                <input type="date" class="form-control form-control-sm" id="valid_from" name="valid_from" onChange={(e) => setUpdateChargeValidFrom(e.target.value)}
                  value={updateChargeValidFrom} onBlur={(e) => e.target.value == "" ? setShowUpdateValidFromError(true) : setShowUpdateValidFromError(false)} />
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="valid_to">Valid To: <i className="text-danger">*</i><span className="text-danger">{showUpdateValidToError ? " Date required" : ""}</span></label>
                <input type="date" class="form-control form-control-sm" id="valid_to" name="valid_to" onChange={(e) => setUpdateChargeValidTo(e.target.value)}
                  value={updateChargeValidTo} onBlur={(e) => e.target.value == "" ? setShowUpdateValidToError(true) : setShowUpdateValidToError(false)} />
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="remarks">Remarks: </label>
                <input type="text" class="form-control form-control-sm" id="remarks" name="remarks" onChange={(e) => setUpdateChargeRemarks(e.target.value)}
                  value={updateChargeRemarks}/>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-1":"col-md-1"} text-left mb-4`}>
                <label for="is_mandatory">Is Mandatory? </label><br></br>
                <input type="checkbox" class="form-checkbox" id="is_mandatory" name="is_mandatory" checked={updateIsMandatoryCharge} onChange={(e) => setUpdateIsMandatoryCharge(e.target.checked)}/>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-1":"col-md-1"} text-left mb-4`}>
                <label for="is_active">Is Active? </label><br></br>
                <input type="checkbox" class="form-checkbox" id="is_active" name="is_active" checked={updateChargeIsActive} onChange={(e) => setUpdateChargeIsActive(e.target.checked)}/>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-12":"col-md-12"} text-left mb-4 text-center`}>
                <Button className="btn btn-inox-green border-0 mt-2 px-5" onClick={(e) => updateTariffCharge(e)}>
                  {showUpdateChargeLoader?
                    <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                  :
                  <>
                    <i className="fa fa-plus"></i> <span className="mx-2">Update</span>
                  </>
                }
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* ------------------------ Update Section ------------------- */}

      {/* ------------------------ Add Section ------------------- */}
      <div class={canvasFullScreen && showAddCanvas?"offcanvas offcanvas-bottom h-100 show":
        !canvasFullScreen && showAddCanvas?"offcanvas offcanvas-bottom h-60 show":"offcanvas offcanvas-bottom h-60"} 
        data-bs-scroll="true" tabindex="-1" id="addSection" aria-labelledby="offcanvasBottomLabel">
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">Add New Record</h4>
            </div>
            <div className="col-6">
              <button type="button" class="btn btn-danger btn-sm float-right" data-bs-dismiss="offcanvas" aria-label="Close" title="Close"
              onClick={() => setShowAddCanvas(false)}>
                  <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen?
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Half Screen" onClick={() => [setCanvasFullScreen(false), setShowAddCanvas(true)]}>
                    <i className="fa fa-window-minimize text-white"></i>
                </button>
                :
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Full Screen" onClick={() => [setCanvasFullScreen(true), setShowAddCanvas(true)]}>
                    <i className="fa fa-window-maximize text-white"></i>
                </button>
              }
            </div>
          </div>
        </div>

        <div class="offcanvas-body" style={{ paddingLeft: 20, paddingRight: 40 }}>
          <form ref={addchargeform} onSubmit={(e) => addTariffCharge(e)}>
            <div className="row">
              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="vendor">Vendor: <i className="text-danger">*</i><span className="text-danger">{showVendorError ? " Vendor required" : ""}</span></label>
                <Select 
                  options={vendorList} 
                  id="vendor" 
                  name="vendor"
                  isMulti={false}
                  isClearable
                  className="px-0"
                  placeholder="Select Vendor"
                  styles={smallFormSelectCustomStyles}
                  onBlur={(e) => e?.value == "" ? setShowVendorError(true) : setShowVendorError(false)}
                />
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="agent">Agent: <i className="text-danger">*</i><span className="text-danger">{showAgentError ? " Agent required" : ""}</span></label>
                <Select 
                  options={agentList} 
                  id="agent" 
                  name="agent"
                  isMulti={false}
                  isClearable
                  className="px-0"
                  placeholder="Select Agent"
                  styles={smallFormSelectCustomStyles}
                  onBlur={(e) => e?.value == "" ? setShowAgentError(true) : setShowAgentError(false)}
                />
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="port">Port: <i className="text-danger">*</i><span className="text-danger">{showPortError ? " Port required" : ""}</span></label>
                <Select 
                  options={portList} 
                  id="port" 
                  name="port"
                  isMulti={false}
                  isClearable
                  className="px-0"
                  placeholder="Select Port"
                  styles={smallFormSelectCustomStyles}
                  onChange={(e) => [getTerminal(e?.value)]}
                  onBlur={(e) => e?.value == "" ? setShowPortError(true) : setShowPortError(false)}
                />
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="charge_name">Charge Name: <i className="text-danger">*</i><span className="text-danger">{showChargeNameError ? " Charge Name required" : ""}</span></label>
                <input type="text" class="form-control form-control-sm" id="charge_name" name="charge_name" placeholder="Enter Charge Name"
                  onBlur={(e) => e.target.value == "" ? setShowChargeNameError(true) : setShowChargeNameError(false)} />
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="charge_type">Product: <i className="text-danger">*</i><span className="text-danger">{showProductError ? " Product required" : ""}</span></label>
                <select className="form-select form-select-sm" name="product"
                  onBlur={(e) => e.target.value == "" ? setShowProductError(true) : setShowProductError(false)}>
                  <option value="" selected>Select Product</option>
                  {productList.map(product => 
                    <option value={product.id}>{product.product_name}</option>
                  )}
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="charge_type">Type: <i className="text-danger">*</i><span className="text-danger">{showChargeTypeError ? " Type required" : ""}</span></label>
                <select className="form-select form-select-sm" name="charge_type" 
                  onBlur={(e) => e.target.value == "" ? setShowChargeTypeError(true) : setShowChargeTypeError(false)}>
                  <option value="" selected>Select Type</option>
                  <option value="HAZARDOUS">HAZARDOUS</option>
                  <option value="NON_HAZARDOUS">NON HAZARDOUS</option>
                  <option value="MIX_HAZARDOUS">MIX HAZARDOUS</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="charge_category">Category: <i className="text-danger">*</i><span className="text-danger">{showChargeCategoryError ? " Category required" : ""}</span></label>
                <select className="form-select form-select-sm" name="charge_category" 
                  onBlur={(e) => e.target.value == "" ? setShowChargeCategoryError(true) : setShowChargeCategoryError(false)}>
                  <option value="" selected>Select Category</option>
                  <option value="FREIGHT">FREIGHT</option>
                  <option value="EXPORT_LOCAL">EXPORT LOCAL</option>
                  <option value="IMPORT_LOCAL">IMPORT LOCAL</option>
                  <option value="SURCHARGE">SURCHARGE</option>
                  <option value="DOCUMENTATION">DOCUMENTATION</option>
                  <option value="CUSTOM">CUSTOM</option>
                  <option value="OTHER">OTHER</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="charge_basis">Basis: <i className="text-danger">*</i><span className="text-danger">{showChargeBasisError ? " Basis required" : ""}</span></label>
                <select className="form-select form-select-sm" name="charge_basis"
                  onBlur={(e) => e.target.value == "" ? setShowChargeBasisError(true) : setShowChargeBasisError(false)}>
                  <option value="" selected>Select Basis</option>
                  <option value="PER_CONTAINER">PER CONTAINER</option>
                  <option value="PER_CBM">PER CBM</option>
                  <option value="PER_KG">PER KG</option>
                  <option value="FLAT">FLAT</option>
                  <option value="PER_SHIPMENT">PER SHIPMENT</option>
                  <option value="PER_BILL">PER BILL</option>
                  <option value="BY_WEIGHT_LIMIT">BY WEIGHT LIMIT</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="amount">Amount: <i className="text-danger">*</i><span className="text-danger">{showAmountError ? " Amount required" : ""}</span></label>
                <input type="text" class="form-control form-control-sm" id="amount" name="amount" placeholder="Enter Amount"
                  onBlur={(e) => e.target.value == "" ? setShowAmountError(true) : setShowAmountError(false)} />
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="amount_type">Amount Type: <i className="text-danger">*</i><span className="text-danger">{showAmountTypeError ? " Type required" : ""}</span></label>
                <select className="form-select form-select-sm" name="amount_type"
                  onBlur={(e) => e.target.value == "" ? setShowAmountTypeError(true) : setShowAmountTypeError(false)}>
                  <option value="" selected>Select Type</option>
                  <option value="AMOUNT">AMOUNT</option>
                  <option value="PERCENTAGE">PERCENTAGE</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="expense">Expense: <i className="text-danger">*</i><span className="text-danger">{showExpenseError ? " Expense required" : ""}</span></label>
                <input type="text" class="form-control form-control-sm" id="expense" name="expense" placeholder="Enter Expense"
                  onBlur={(e) => e.target.value == "" ? setShowExpenseError(true) : setShowExpenseError(false)} />
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="currency">Currency: <i className="text-danger">*</i><span className="text-danger">{showChargeCurrencyError ? " Currency required" : ""}</span></label>
                <select className="form-select form-select-sm" name="currency"
                  onBlur={(e) => e.target.value == "" ? setShowChargeCurrencyError(true) : setShowChargeCurrencyError(false)}>
                  <option value="" selected>Select Currency</option>
                  {currencyList.map(currency => 
                    <option value={currency.id}>{currency.name} ({currency.symbol})</option>
                  )}
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="is_terminal_specific">Is Terminal Specific? </label>
                <select className="form-select form-select-sm" name="is_terminal_specific" onChange={(e) => [setIsTerminalSpecificCharge(e.target.value), setChargeTerminal("")]}>
                  <option value="NO">NO</option>
                  <option value="YES">YES</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="terminal">Terminal: <i className="text-danger">*</i><span className="text-danger">{showTerminalError ? " Terminal required" : ""}</span></label>
                <select className="form-select form-select-sm" name="terminal" onChange={(e) => setChargeTerminal(e.target.value)} value={chargeTerminal}
                  onBlur={(e) => e.target.value == "" ? setShowTerminalError(true) : setShowTerminalError(false)} disabled={isTerminalSpecificCharge=="NO"|isTerminalSpecificCharge==""?true:false}>
                  <option value="" selected>Select Terminal</option>
                  {terminalList.map(terminal => 
                    <option value={terminal.id}>{terminal.name}</option>
                  )}
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="applicable_for">Applicable For: <i className="text-danger">*</i><span className="text-danger">{showApplicableForError ? " Option required" : ""}</span></label>
                <select className="form-select form-select-sm" name="applicable_for"
                  onBlur={(e) => e.target.value == "" ? setShowApplicableForError(true) : setShowApplicableForError(false)}>
                  <option value="" selected>Select Applicable For</option>
                  <option value="POA">POA</option>
                  <option value="POL">POL</option>
                  <option value="POD">POD</option>
                  <option value="FD">FD</option>
                  <option value="TSP">TSP</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="event_type">Event Type: </label>
                <select className="form-select form-select-sm" name="event_type">
                  <option value="NONE" selected>Select Event Type</option>
                  <option value="EXPORT_PAYABLE">EXPORT PAYABLE</option>
                  <option value="EXPORT_RECEIVABLE">EXPORT RECEIVABLE</option>
                  <option value="IMPORT_PAYABLE">IMPORT PAYABLE</option>
                  <option value="IMPORT_RECEIVABLE">IMPORT RECEIVABLE</option>
                  <option value="RAIL_TO_SEA_TSP_EXPORT_PAYABLE">RAIL TO SEA TSP EXPORT PAYABLE</option>
                  <option value="RAIL_TO_SEA_TSP_IMPORT_PAYABLE">RAIL TO SEA TSP IMPORT PAYABLE</option>
                  <option value="SEA_TO_RAIL_TSP_EXPORT_PAYABLE">SEA TO RAIL TSP EXPORT PAYABLE</option>
                  <option value="SEA_TO_RAIL_TSP_IMPORT_PAYABLE">SEA TO RAIL TSP IMPORT PAYABLE</option>
                  <option value="SEA_TO_SEA_TSP_EXPORT_PAYABLE">SEA TO SEA TSP EXPORT PAYABLE</option>
                  <option value="SEA_TO_SEA_TSP_IMPORT_PAYABLE">SEA TO SEA TSP IMPORT PAYABLE</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="event_sub_type">Event Sub Type: </label>
                <select className="form-select form-select-sm" name="event_sub_type">
                  <option value="NONE" selected>Select Event Sub Type</option>
                  <option value="ALL_CONTAINERS_PICKED">ALL CONTAINERS PICKED</option>
                  <option value="BL_MARKED_EXPRESS">BL MARKED EXPRESS</option>
                  <option value="BL_MARKED_SEAWAY">BL MARKED SEAWAY</option>
                  <option value="BL_SURRENDERED">BL SURRENDERED</option>
                  <option value="CERTIFICATE_ISSUED">CERTIFICATE ISSUED</option>
                  <option value="REACHED_FD">REACHED FD</option>
                  <option value="REACHED_TSP">REACHED TSP</option>
                  <option value="SHIPPED_ON_BOARD">SHIPPED ON BOARD</option>
                  <option value="SOB_FROM_TSP">SOB FROM TSP</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="payable_by">Payable By </label>
                <select className="form-select form-select-sm" name="payable_by">
                  <option value="SHIPPER">SHIPPER</option>
                  <option value="CONSIGNEE">CONSIGNEE</option>
                  <option value="AGENT">AGENT</option>
                  <option value="LINE">LINE</option>
                  <option value="CUSTOMER">CUSTOMER</option>
                  <option value="THIRD_PARTY">THIRD PARTY</option>
                </select>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="valid_from">Valid From: <i className="text-danger">*</i><span className="text-danger">{showValidFromError ? " Date required" : ""}</span></label>
                <input type="date" class="form-control form-control-sm" id="valid_from" name="valid_from"
                  onBlur={(e) => e.target.value == "" ? setShowValidFromError(true) : setShowValidFromError(false)} />
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="valid_to">Valid To: <i className="text-danger">*</i><span className="text-danger">{showValidToError ? " Date required" : ""}</span></label>
                <input type="date" class="form-control form-control-sm" id="valid_to" name="valid_to"
                  onBlur={(e) => e.target.value == "" ? setShowValidToError(true) : setShowValidToError(false)} />
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                <label for="remarks">Remarks: </label>
                <input type="text" class="form-control form-control-sm" id="remarks" name="remarks"/>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-1":"col-md-1"} text-left mb-4`}>
                <label for="is_mandatory">Is Mandatory? </label><br></br>
                <input type="checkbox" class="form-checkbox" id="is_mandatory" name="is_mandatory"/>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-1":"col-md-1"} text-left mb-4`}>
                <label for="is_active">Is Active? </label><br></br>
                <input type="checkbox" class="form-checkbox" id="is_active" name="is_active"/>
              </div>

              <div class={`form-group ${canvasFullScreen?"col-md-12":"col-md-12"} text-left mb-4 text-center`}>
                <Button className="btn btn-inox-green border-0 mt-2 text-center px-5" onClick={(e) => addTariffCharge(e)}>
                  {showAddChargeLoader?
                    <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                  :
                  <>
                    <i className="fa fa-plus"></i> <span className="mx-2">Add</span>
                  </>
                }
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* ------------------------ Add Section ------------------- */}
    </div>
  );
}

export default TariffCharge;
